export default __webpack_public_path__ + "static/media/0xa8fcee762642f156b5d757b6fabc36e06b6d4a1a.4cb98f86.webp";